// Components==============
import indexUser from 'actions/user/index';
import { ShouldDispatchType } from 'components/UI/AddUserModal/AddUserModal';
import { useReduxAction } from 'hooks/useReduxAction';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import { useContext, useEffect } from 'react';
// =========================

export default function useSearchUsers({
  value,
  setSearchResults,
  shouldDispatch,
  setShouldDispatch,
  searchFilter,
  includeSelf,
  includeExtern,
  projectId,
}: {
  value: string;
  setSearchResults: React.Dispatch<React.SetStateAction<UserEntity[]>>;
  shouldDispatch: ShouldDispatchType;
  setShouldDispatch: React.Dispatch<React.SetStateAction<ShouldDispatchType>>;
  searchFilter?: (user: UserEntity) => boolean;
  includeSelf?: boolean;
  includeExtern?: boolean;
  projectId?: number;
}) {
  const dispatch = useReduxAction();

  const { rootProject } = useContext(ProjectDetailsContext);

  useEffect(() => {
    if (!value) return setSearchResults([]);

    if (shouldDispatch === 'initial') {
      setShouldDispatch('pending');
    }
  }, [value]);

  useEffect(() => {
    if (shouldDispatch === 'initial') return;

    if (shouldDispatch === 'pending') {
      const timeout = setTimeout(() => {
        setShouldDispatch('dispatch');
      }, 750);

      return () => clearTimeout(timeout);
    }

    if (shouldDispatch === 'dispatch') {
      dispatch(
        indexUser({
          search: value,
          project_id: rootProject?.id || projectId,
          include_self: includeSelf,
          include_extern: includeExtern,
        })
      )
        .then((res: UserEntity[]) => {
          setShouldDispatch('initial');
          setSearchResults([
            ...res
              .filter((u) => !!u.avatar_url)
              .filter(searchFilter || ((e) => e)),
          ]);
        })
        .catch((error) => {
          console.error(error);
          setShouldDispatch('initial');
        });
    }
  }, [shouldDispatch]);
}
